

import { api } from "@services/axiosConfigs";
import { defineCancelApiObject } from "@services/axiosUtils";

export const IrancellAPI = {
  login: async function (username,password, cancel = false) {
    const response = await api.request({
      url: `/auth/token/2fa/login/`,
      method: "POST",
      data:{
        "password": password,
        "username": username
      },
      // retrieving the signal value by using the property name
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    // returning the Irancell returned by the API
    return response.data;
  }
};

// defining the cancel API object for IrancellAPI
const cancelApiObject = defineCancelApiObject(IrancellAPI);